<template>
    <div class="drawer-sections">
        <div>
            <div class="dr-sec-h">Триггеры уведомлений</div>
            <p class="dr-sec-p">
                Настройте, какие события запускают сервисные сообщения: напоминание о записи, подтверждение брони,
                уведомление об отмене или переносе.
            </p>
            <a class="dr-link-btn" :href="triggersUrl" target="_blank" rel="noopener">
                Перейти к триггерам
                <v-icon class="dr-link-btn__icon" size="13" color="white">mdi-arrow-right</v-icon>
            </a>
        </div>
        <div class="dr-divider"></div>
        <div>
            <div class="dr-sec-h">Режим работы по умолчанию</div>
            <p class="dr-sec-p">
                Режим работы для сервисных уведомлений по умолчанию (рекомендуем изначально подключить тестовый режим).
            </p>
            <div class="dr-radio-group">
                <label class="dr-radio">
                    <input v-model="scenario.settings.mode" type="radio" value="test" />
                    <span class="dr-radio-dot"></span>Тестовый режим
                </label>
                <label class="dr-radio">
                    <input v-model="scenario.settings.mode" type="radio" value="battle" />
                    <span class="dr-radio-dot"></span>Боевой режим
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StarterPackDrawerBattle',
    props: {
        scenario: {
            type: Object,
            required: true,
        },
        triggersUrl: {
            type: String,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.dr-sec-h {
    margin-bottom: 8px;
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 13.5px;
    font-weight: 800;
    letter-spacing: -0.01em;
}

.dr-sec-p {
    margin-bottom: 14px;
    color: $muted-new;
    font-size: 12.5px;
    line-height: 1.5;
}

.dr-link-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 11px 17px;
    color: #fff;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 12.5px;
    font-weight: 700;
    text-decoration: none;
    background: $main-new;
    border: 0;
    border-radius: 9px;
    box-shadow: 0 2px 10px rgba(82, 90, 213, 0.26);
    cursor: pointer;
    transition: 0.15s;
}

.dr-link-btn:hover {
    background: #454cc0;
    transform: translateY(-1px);
}

.dr-link-btn__icon ::v-deep .v-icon {
    color: #fff !important;
}

.dr-divider {
    height: 1px;
    background: $border-new;
    margin: 0;
}

.drawer-sections {
    display: flex;
    flex-direction: column;
    gap: 22px;
}

.dr-radio-group {
    display: flex;
    flex-direction: column;
    gap: 11px;
}

.dr-radio {
    display: flex;
    align-items: center;
    gap: 10px;
    color: $text-color-new;
    font-size: 13.5px;
    cursor: pointer;
}

.dr-radio input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
}

.dr-radio-dot {
    position: relative;
    flex-shrink: 0;
    width: 19px;
    height: 19px;
    border: 2px solid #c7cdda;
    border-radius: 50%;
}

.dr-radio input:checked + .dr-radio-dot {
    border-color: $main-new;
}

.dr-radio input:checked + .dr-radio-dot::after {
    position: absolute;
    inset: 3px;
    background: $main-new;
    border-radius: 50%;
    content: '';
}

.dr-radio:hover .dr-radio-dot {
    border-color: $main-new;
}
</style>
